// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1ampP","bigColWidth":"Table_bigColWidth__2-cIW","biggerColWidth":"Table_biggerColWidth__2pSCA","row":"Table_row__2WfeZ","col":"Table_col__2O-l9"};